import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CortesService } from "../../servicios/cortes.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Cortes, RegistroBitacoraInput } from '../../entidades/entidades';
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';
import { DotacionInicialService } from "../../servicios/dotacion-inicial.service";

@Component({
  selector: 'app-cortes-apertura',
  templateUrl: './cortes-apertura.component.html',
  styleUrls: ['./cortes-apertura.component.css']
})
export class CortesAperturaComponent implements OnInit 
{
  muestraMensaje = new MuestraMensaje();
  datosAperturaTable : Cortes;
  idUser: number;
  estatusCaja: string;
  ContinuaSesion:boolean = false;
  
  fecha_apertura : Date;
  fecha_Actual;
  fecha_hoy;
  public registroBitacora = new RegistroBitacoraInput();

  @Input("cortes") cortes: Cortes;
  @Output("cortesOutput") cortesOutput: EventEmitter<Cortes>;

  constructor(
    private cortesService: CortesService,
    private registroBitacoraService: RegistroBitacoraService,
    private dotacionInicialService: DotacionInicialService

  ) { 
    this.cortesOutput = new EventEmitter()
  }

  ngOnInit(): void {

      var date = new Date(new Date());
      var dayActual = date.getDate().toString().padStart(2,'0');
      var monthIndexActual = (date.getMonth() + 1).toString().padStart(2,'0');
      var yearActual = date.getFullYear();
      
      
      this.fecha_hoy = yearActual+"-"+monthIndexActual+"-"+dayActual;

    if(this.cortes)
    {
      console.log("Entra a Cortes Aperturas: ", this.cortes);
      this.idUser = this.cortes[0];
      this.getCortes(this.cortes.idUsuarioCajero);
    }else{
      console.log("Entra a Cortes Aperturas: ", this.cortes);
    }
  }

  async getCortes(id: number) {
    try {
      console.log('Usuario: ', id);
        var datoRetorno = await this.cortesService
        .getSingle(id)
        .toPromise();
        
        console.log('Carga Cortes del Usuario:', datoRetorno);
        
        this.datosAperturaTable = datoRetorno;

        this.cortes = datoRetorno;

        this.getCorteUsuario(this.cortes[0]);

    

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCortes");
    }
  }

  async guardar()
  {
    this.cortesOutput.emit(this.cortes);
  }  

  async getCorteUsuario(Cortes: Cortes) {
    try {
      console.log('Imprime: ', Cortes);
      var datoRetorno = await this.cortesService
        .getBusquedas(Cortes)
        .toPromise();

      
      this.fecha_apertura = datoRetorno.fechaApertura;
      
      var date = new Date(new Date());
      var dayActual = date.getDate();
      var monthIndexActual = date.getMonth() + 1;
      var yearActual = date.getFullYear();
      this.fecha_Actual = yearActual+"-"+monthIndexActual+"-"+dayActual;

      var date = new Date(datoRetorno.fechaApertura);
      var day = date.getDate();
      var monthIndex = date.getMonth() + 1;
      var year = date.getFullYear();
      var fechaApertura = year+"-"+monthIndex+"-"+day;

      

      if(fechaApertura == this.fecha_Actual)
      {
        this.ContinuaSesion = true;
      }else
      {
        this.ContinuaSesion = false;
      }

        
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCortes");
    }
  }

  async cierraCaja(corte : Cortes)
  {
    console.log("Corte Act: ",corte);
    let date: Date = new Date();


    corte.fechaCierre = date;

    const datoRetorno = await this.cortesService
        .update(corte)
        .toPromise();
        console.log("cortes: ", datoRetorno);
        this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
        
        corte.id = 0;
        this.cortesOutput.emit(corte);
        
        
        this.registroBitacora.accion = "CORTE DE CAJA " ;
        const retorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();

        // Establece dotación inicial a 0
        this.dotacionInicialService.setDotacionInicial(0);

  }  
  

}
